
export const productCategoryStore = {
  tree: {}
};
